module.exports = __webpack_public_path__ + "static/Viber-6486065fe4f3548de7b8224f905e9711.png";